import React from "react";

import {
  components,
  GroupBase,
  OptionProps,
  SingleValueProps
} from "react-select";

export default {
  Option: customOption,
  SingleValue: customSingleValue
};

// Created for while we're using localizeJS to manage our translations
// can probably be removed once we have our own management system in place
export function customOption<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>(props: OptionProps<Option, IsMulti, Group>) {
  const { children, ...otherProps } = props;
  return (
    <components.Option {...otherProps}>
      <span data-notranslate>{children}</span>
    </components.Option>
  );
}

export function customSingleValue<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>(props: SingleValueProps<Option, IsMulti, Group>) {
  const { children, ...otherProps } = props;
  return (
    <components.SingleValue {...otherProps}>
      <span data-notranslate>{children}</span>
    </components.SingleValue>
  );
}
